/**
 * The grid's toast (spec M1-B4 §8.4).
 *
 * Every grid mutation — clear, paste, cell edit, row delete/archive — shows a 10 s toast with
 * **Undo**; the paste summary reuses the same surface. `role="status"`, so a screen reader
 * announces it without stealing focus (§8.13).
 */
import { useEffect } from 'react';
import { useTable, useTableActions } from './context';
import { UNDO_TOAST_MS } from './undo';

export function UndoToast() {
  const toast = useTable((state) => state.toast);
  const actions = useTableActions();

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => actions.dismissToast(), UNDO_TOAST_MS);
    return () => clearTimeout(timer);
  }, [toast, actions]);

  if (!toast) return null;

  return (
    <div className="ez-grid-toast" role="status" data-kind={toast.kind} data-testid="grid-toast">
      <span>{toast.message}</span>
      {toast.actionLabel ? (
        <button
          type="button"
          className="ez-grid-toast__action"
          data-testid="grid-toast-action"
          onClick={() => {
            // P-050: this toast's own entry, not "the last thing on the stack".
            const entryId = toast.undoEntryId;
            actions.dismissToast();
            void actions.undoLast(entryId);
          }}
        >
          {toast.actionLabel}
        </button>
      ) : null}
      <button
        type="button"
        className="ez-grid-toast__close"
        aria-label="Dismiss"
        onClick={() => actions.dismissToast()}
      >
        ×
      </button>
    </div>
  );
}
